"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberFormatter = void 0;
const React = require("react");
const react_1 = require("react");
class NumberFormatter extends react_1.Component {
    render() {
        const value = Number(this.props.value);
        let text = value.toLocaleString(undefined, {
            style: "currency",
            currency: "USD"
        });
        if (text === "$NaN" || !value) {
            text = "";
            if (value === 0) {
                text = "$0.00";
            }
        }
        return React.createElement("span", null, text);
    }
}
exports.NumberFormatter = NumberFormatter;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/claim-analytics/number-formatter.tsx
// module id = 174
// module chunks = 0